import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "components/AppIcon";

// Upcoming milestones — updated to reference canonical asset names
const milestones = [
  {
    id: 1,
    title: "Solano Wind Farm — Annual Review",
    project: "Solano Wind Farm SPV",
    date: "30/09/2026",
    daysLeft: 208,
    status: "upcoming",
    type: "Review",
    icon: "Zap",
    route: "/spv-dashboard",
  },
  {
    id: 2,
    title: "IC Approval — Thames Tidal Power",
    project: "Thames Tidal Power SPV",
    date: "18/03/2026",
    daysLeft: 13,
    status: "upcoming",
    type: "IC Review",
    icon: "CheckSquare",
    route: "/spv-dashboard",
  },
  {
    id: 3,
    title: "Quarterly Distribution",
    project: "Porto Digital Hub SPV",
    date: "31/03/2026",
    daysLeft: 26,
    status: "scheduled",
    type: "Distribution",
    icon: "ArrowDownCircle",
    route: "/spv-dashboard",
  },
  {
    id: 4,
    title: "KYC Renewal Deadline",
    project: "Investor Compliance",
    date: "05/04/2026",
    daysLeft: 31,
    status: "action-required",
    type: "Compliance",
    icon: "ShieldCheck",
    route: "/investor-onboarding",
  },
  {
    id: 5,
    title: "Construction Milestone — Elbe Biomass",
    project: "Elbe Biomass Plant SPV",
    date: "15/04/2026",
    daysLeft: 41,
    status: "scheduled",
    type: "Construction",
    icon: "Award",
    route: "/spv-dashboard",
  },
];

const statusConfig = {
  upcoming: { label: "Upcoming", color: "var(--color-primary)", bg: "rgba(59,76,76,0.08)" },
  scheduled: { label: "Scheduled", color: "var(--color-success)", bg: "rgba(5,150,105,0.08)" },
  "action-required": { label: "Action Required", color: "var(--color-warning)", bg: "rgba(217,119,6,0.1)" },
};

export default function MilestonesPanel() {
  const navigate = useNavigate();

  return (
    <div className="card h-full" style={{ padding: 0 }}>
      <div className="flex items-center justify-between px-5 py-4 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="CalendarClock" size={18} color="var(--color-primary)" />
          <h3 className="font-heading font-semibold text-foreground" style={{ fontSize: "1rem" }}>
            Upcoming Milestones
          </h3>
        </div>
        <span className="font-data text-muted-foreground text-xs">{milestones?.length} items</span>
      </div>
      <div className="divide-y divide-border">
        {milestones?.map((m) => {
          const sc = statusConfig?.[m?.status];
          return (
            <button
              key={m?.id}
              onClick={() => navigate(m?.route)}
              className="w-full flex items-start gap-3 px-5 py-3.5 text-left hover:bg-muted transition-all duration-250 group"
            >
              <div
                className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-md mt-0.5"
                style={{ background: sc?.bg }}
              >
                <Icon name={m?.icon} size={15} color={sc?.color} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-caption font-medium text-foreground text-sm truncate group-hover:text-primary transition-colors">
                  {m?.title}
                </p>
                <p className="font-caption text-muted-foreground truncate" style={{ fontSize: "0.75rem" }}>
                  {m?.project}
                </p>
              </div>
              <div className="flex-shrink-0 text-right">
                <p className="font-data text-foreground text-xs whitespace-nowrap">{m?.date}</p>
                <span
                  className="inline-block mt-1 px-2 py-0.5 rounded-full font-caption font-medium whitespace-nowrap"
                  style={{ fontSize: "0.6875rem", color: sc?.color, background: sc?.bg }}
                >
                  {m?.daysLeft}d
                </span>
              </div>
            </button>
          );
        })}
      </div>
      <div className="px-5 py-3 border-t border-border">
        <button
          onClick={() => navigate("/spv-dashboard")}
          className="font-caption text-primary text-sm hover:underline transition-all"
        >
          View all milestones →
        </button>
      </div>
    </div>
  );
}